<template>
	<div class="goods-intro">
		<div class="intro-divide" style="width: 60%;padding-right:120px;box-sizing:border-box;">
			<div class="intro-title">新增模块</div>
			<div class="add-box">
				<div class="add-top">
					<div class="add-btn" @click="addClick(1)"><img src="~/images/icon/intro-text.png">添加文字模块（{{textNum}}/10）</div>
					<div class="add-btn" @click="addClick(2)"><img src="~/images/icon/intro-img.png">添加图片模块（{{imgNum}}/10）</div>
				</div>
				<div class="add-scroll">
					<div v-for="(item, index) in addList" :key="index" class="add-wrap">
						<div class="add-text" v-if="item.type === 1">
							<!-- <wangEditor
								v-if="item.type === 1"
								:atItem="item"
								:initHtml="item.caption"
								@change="editorChange"
							/> -->
							<div style="border: 1px solid #ccc;" class="forbid">
								<Toolbar
									style="border-bottom:1px solid#ccc;"
									:editor="item.editor"
									:defaultConfig="toolbarConfig"
									:mode="mode"
								/>
								<Editor
									style="height:140px; overflow-y:hidden;"
									v-model="item.caption"
									:defaultConfig="editorConfig"
									:mode="mode"
									@onCreated="onCreated($event, item)"
									@onChange="paintList"
								/>
							</div>
						</div>
						<div class="add-img" v-if="item.type === 2">
							<ImgUploadIntro
								:imgSrc.sync="item.url"
								:seqnum="index"
								@updateImg="updateImg"
								ref="showUpload"
							/>
						</div>
						<div class="add-index">{{index + 1}}</div>
						<div class="sort-box">
							<img v-show="index !== 0" @click="moveClick(index, 'up')" src="~/images/icon/up-btn.png"/>
							<img v-show="index !== addList.length-1" @click="moveClick(index, 'down')" src="~/images/icon/down-btn.png"/>
							<img @click="moveClick(index, 'del')" src="~/images/icon/del-btn.png"/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="intro-divide" style="width: 40%">
			<div class="intro-title">效果预览</div>
			<div class="look-box">
				<div v-for="(item, index) in lookList" :key="index">
					<div class="look-text" v-if="item.type === 1" v-html="item.caption"></div>
					<div class="look-img" v-if="item.type === 2"><img :src="item.url"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import draggable from 'vuedraggable'
import ImgUploadIntro from '@/components/storeSetting/saleableGoods/ImgUploadIntro.vue'
// import wangEditor from '@/components/storeSetting/saleableGoods/editor.vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
// import { DomEditor } from '@wangeditor/editor'
export default {
	name: 'goodsIntro',
	components: {
		ImgUploadIntro,
		// draggable,
		// wangEditor
		Editor,
		Toolbar
	},
	props: {
		customerDialog: Boolean,
		chooseData1: Array
	},
	data () {
		return {
			editor: null,
			html: '',
			editorList: [],
			toolbarConfig: {
				toolbarKeys: ['bold', 'fontSize', 'color', {
					key: 'group-justify', // 必填，要以 group 开头
					title: '对齐', // 必填
					iconSvg: '<svg viewBox=\"0 0 1024 1024\"><path d=\"M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z\"></path></svg>', // 可选
					menuKeys: ['justifyLeft', 'justifyRight', 'justifyCenter'] // 下级菜单 key ，必填
				}]
				// excludeKeys: [ /* 隐藏哪些菜单 */ ]
			},
			editorConfig: { placeholder: '请输入内容...' },
			mode: 'simple', // or 'default'
			addList: [],
			lookList: [],
			disable: false,
			textNum: 0,
			imgNum: 0
		}
	},
	created () {
	},
	mounted () {
		// 模拟 ajax 请求，异步渲染编辑器
		// setTimeout(() => {
		// 	const toolbar = DomEditor.getToolbar(this.editor)
		// 	const curToolbarConfig = toolbar.getConfig()
		// 	console.log(curToolbarConfig.toolbarKeys)
		// 	this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
		// }, 1500)
	},
	methods: {
		onCreated (editor, item) {
			// this.$nextTick(() => {
			// 	item.editor = Object.seal(editor)
			// 	// this.editorList[index].editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
			// 	// this.$set(this.editorList[index], 'editor', Object.seal(editor))
			// })
			item.editor = Object.seal(editor)
		},
		// editorChange (value, item) {
		// item.caption = value
		// },
		moveClick (index, type) {
			if (type === 'up') {
				this.swapArray(this.addList, index - 1, index)
			} else if (type === 'down') {
				this.swapArray(this.addList, index, index + 1)
			} else {
				let list = this.$fxUtils.deepClone(this.addList)
				list.splice(index, 1)
				this.addList = list
				this.checkNum()
			}
			this.paintList()
		},
		swapArray (arr, index1, index2) {
			arr[index1] = arr.splice(index2, 1, arr[index1])[0]
			return arr
		},
		paintList () {
			let list = this.$fxUtils.deepClone(this.addList)
			for (var i = 0; i < list.length; i++) {
				let item = list[i]
				if ((item.type === 1 && item.caption === '<p><br></p>') || (item.type === 2 && !item.url)) {
					list.splice(i--, 1)
				}
			}
			this.lookList = list
		},
		checkNum () {
			this.textNum = this.addList.filter(item => { return item.type === 1 }).length
			this.imgNum = this.addList.filter(item => { return item.type === 2 }).length
		},
		addClick (type) {
			if ((type === 1 && this.textNum >= 10) || (type === 2 && this.imgNum >= 10)) {
				return false
			}
			let obj = {
				id: '',
				type: type,
				caption: '',
				editor: null,
				url: '',
				oldUrl: ''
			}
			this.addList.push(obj)
			this.checkNum()
		},
		updateImg (obj) {
			const item = this.addList[obj.index]
			if (item.id) {
				const oldUrl = this.$fxUtils.deepClone(this.addList[obj.index].url)
				this.addList[obj.index].oldUrl = oldUrl
				this.addList[obj.index].url = obj.url
			} else {
				this.addList[obj.index].url = obj.url
			}
			this.paintList()
		}
	}
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="stylus">
	.w-e-toolbar {
		padding-left: 20px
		z-index: 2!important;
	}
	.w-e-menu {
		z-index: 2 !important;
	}
	.w-e-text-container {
		z-index: 1 !important;
	}
</style>
<style lang="stylus" scoped>
.goods-intro {
	padding: 16px 40px;
	border-radius: 4px;
	border: 1px solid #E4E4E4;
	display: flex
	.intro-title {
		font-size: 16px
		margin-bottom: 16px
		text-align: left
	}
	.add-box {
		padding: 16px;
		padding-right: 0
		box-sizing: border-box;
		background: #F1F2F3;
		border-radius: 4px;
		position: relative
		height: 667px;
		.add-top {
			display: flex
			.add-btn {
				width: 199px;
				height: 48px;
				background: #FFF;
				box-shadow: 0px 0px 4px 0px rgba(174,174,174,0.5);
				border-radius: 10px;
				color: #333;
				font-size: 14px
				margin-right: 10px
				display: flex
				justify-content: center
				align-items: center
				cursor: pointer
				img {
					width: 22px
					height: 22px
					margin-right: 7px
				}
			}
		}
		.add-scroll {
			height: 568px;
			// overflow-x: hidden;
			overflow-y: auto;
			margin-top: 16px;
		}
		.add-wrap {
			&:last-of-type {
				margin-bottom: 0
			}
			position: relative
			width: 100%;
			display: flex
			justify-content: space-between
			margin-bottom: 16px;
		}
		.add-text {
			flex: 1
			height: 180px;
		}
		.add-img {
			width: 110px;
			height: 110px;
		}
		// .component-box {
		// 	max-height: 600px;
		// 	overflow-y: auto;
		// }
		.add-index {
			width: 26px;
			height: 26px;
			text-align: center;
			line-height: 26px;
			background: #E1EEFD;
			border-radius: 10px 0px 10px 0px;
			font-size: 16px
			position: absolute
			left: 0;
			top: 0;
			z-index: 9;
		}
		.sort-box {
			width:33px;
			align-items: center;
			justify-content: space-around;
			box-sizing: border-box;
			height: 92px;
			background-color: #fff;
			margin: 1px 10px;
			// position: absolute;
			// right: -45px;
			// top: 0;
			display: flex;
			flex-direction: column;
			box-shadow: 0px 0px 4px 0px rgba(174,174,174,0.5);
			border-radius: 10px;
			img{
				width: 17px;
				height: 17px;
				cursor: pointer
			}
		}
	}
	.look-box {
		width: 298px;
		padding: 16px;
		padding-top: 0;
		box-sizing: border-box;
		border-radius: 4px;
		border: 1px solid #E4E4E4;
		height: 664px;
		overflow: hidden;
		overflow-y: auto;
		.look-text {
			margin-top: 20px
		}
		.look-img {
			margin-top: 10px
			img {
				width: 260px;
				height: 146px;
			}
		}
	}
}
</style>
